<script setup lang="ts">
import type { StockStatusPillType } from './StockStatusPill.models';

const props = defineProps<{
  type: StockStatusPillType;
  message: string;
}>();
</script>

<template>
  <span class="stock-status-pill" :class="`stock-status-pill--${props.type}`">
    <span class="stock-status-pill__dot" aria-hidden="true"></span>
    <span class="stock-status-pill__text">{{ props.message }}</span>
  </span>
</template>
